import {useState} from "react";
import {useLocation} from "react-router-dom";
import {useMutation} from "@apollo/client";
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";

import {GET_ALL_CONTENT_DATA, REMOVE_CONTENT_INFO_PARENT} from "../../../queries/GraphQLQueries";
import CustomAlert from "../../CustomAlert";
import {useDialogNavigation} from "../../../hooks/useDialogNavigation";

export default function RemoveContentInfoParentDialog() {
    const handleClose = useDialogNavigation();
    const {state} = useLocation();

    const [alertMessage, setAlertMessage] = useState(null);
    const {sourceNodeId, sourceNodeName, targetNodeName} = state || {};

    const [removeContentInfoParentMutation] = useMutation(REMOVE_CONTENT_INFO_PARENT, {refetchQueries: [{ query: GET_ALL_CONTENT_DATA }, 'GetAllContentData']});

    const handleCloseCustomAlert = () => setAlertMessage(null);

    const handleMove = () => {
        removeContentInfoParentMutation({
            variables: {
                contentInfoId: sourceNodeId
            }
        }).then(() => handleClose())
        .catch((e) => {
            setAlertMessage({children: e?.message, severity: 'error'});
            return false;
        });
    }

    return (
      <>
          <Dialog open={true} onClose={handleClose}>
              <DialogTitle>Move Content Definition</DialogTitle>

              <DialogContent>
                  <Typography variant={"body"}>{`This will move content definition '${sourceNodeName}' directly under '${targetNodeName}'. Are you sure you want to proceed?`}</Typography>
              </DialogContent>
              <DialogActions>
                  <Button onClick={handleClose} variant="contained">Cancel</Button>
                  <Button onClick={handleMove} variant="contained">Move</Button>
              </DialogActions>
          </Dialog>
          <CustomAlert alertMessage={alertMessage} handleCloseCustomAlert={handleCloseCustomAlert}/>
      </>
    );
}
